import { BaseApiRouteService } from "mrb/core";

class NakiNigunAlbumTrackProducerApiRouteService extends BaseApiRouteService {
    constructor() {
        super("naki-nigun/track-producers");
    }

    updateTrackProducers(trackId) {
        return super.update(`${this.base}/{id}`, { id: trackId });
    }
}

export default NakiNigunAlbumTrackProducerApiRouteService;
